import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { DiagnosticReport } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface UpdateResultSummaryParams {
  text: string;
}

interface UpdateResultSummaryResponse {
  diagnosticReport: DiagnosticReport;
}

export const useUpdateResultSummary = ({
  patientId,
  diagnosticReportId,
}: {
  patientId: string;
  diagnosticReportId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<UpdateResultSummaryResponse, UpdateResultSummaryParams>(
    {
      mutationOptions: {
        mutationKey:
          QueryKeys.Patient.MedicalRecords.Labs.UPDATE_RESULT_SUMMARY(
            patientId,
            diagnosticReportId,
          ),
        mutationFn: (params: UpdateResultSummaryParams) => {
          return axiosInstance.put(
            `/labs/results/${diagnosticReportId}/result-summary`,
            { text: params.text },
          );
        },
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
          });
        },
      },
    },
  );
};
